<template>
  <metainfo></metainfo>
  <template v-if="isForbiddenPage()">
    <NoPermission />
  </template>
  <template v-else>
    <div class="page-header d-print-none" id="post-tags">
      <div class="container-xl">
        <div class="row g-2 align-items-center">
          <div class="col-sm">
            <h2 class="page-title">
              <router-link class="link" :to="{name: 'PostArticles'}">Статьи</router-link>/ Теги для статей
            </h2>
          </div>
          <div class="col-auto">
            <button class="btn btn-primary" data-bs-toggle="modal" data-type="create" :data-bs-target="'#modal-tag'">
              <IconCirclePlus />
              Создать
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="container-xl">
        <div class="mb-3">
          <TagFilter @onFilter="onFilter" :params="getParams()" />
        </div>
        <div ref="scrollComponent">
          <TagList :query="getQuery()" @onRender="onRender" :clear-result="getClearResult()" />
        </div>
      </div>
    </div>
    <Teleport to="body">
      <Modal @onUpdate="onUpdate" @onCreate="onCreate" @onDelete="onDelete"/>
    </Teleport>
  </template>
</template>
<script>
import {defineComponent, onMounted, onUnmounted, ref} from 'vue'
import TagFilter from "./components/filter/Index"
import TagList from "./components/list/Index"
import Modal from './components/modals/create_update/Index'
import IconCirclePlus from '@/assets/icons/IconCirclePlus'
import {useMeta} from "vue-meta"
import Helper from "@/services/Helper"
import Permission from "@/modules/users/services/Permission"
import NoPermission from "@/modules/auth/pages/no_permission/Index"
import {editorRoleId} from "@/modules/auth/services/role"

export default defineComponent({
  name: "Tags",
  components: {
    TagFilter,
    TagList,
    Modal,
    IconCirclePlus,
    NoPermission,
  },
  setup() {
    useMeta({title: "Теги"})

    const scrollComponent = ref(null)

    let query = ref({})
    let clearResult = ref(false)
    let offset = ref(0)
    let eofResult = ref(false)
    let countPosts = ref(0)
    let isLoading = ref(false)
    let noPermission = ref(false)
    let scroll = () => {
      isLoading.value = true
      offset.value += 18

      onLoadMore(offset.value)
    }
    let params = {
      search: "",
      categories: [],
      enable: true,
    }

    function onRender(payload) {
      eofResult.value = payload["oef_items"] === true
      if (payload["count_items"] > 0) {
        countPosts.value = payload["count_items"];
      }
      clearResult.value = false
      isLoading.value = false
    }

    function onFilter(q) {
      clearResult.value = true
      offset.value = 0
      eofResult.value = false
      countPosts.value = 0

      q = Helper.mergeObject(q, {
        "limit": 18,
        "offset": offset.value,
      })

      q = Helper.clone(q)

      query.value = q
    }

    function onLoadMore(offset) {
      if (Helper.isEmptyObject(query.value)) {
        return false
      }

      let q = Helper.clone(query.value)

      query.value = Helper.mergeObject(q, {
        "offset": offset,
      })
    }

    const handleScroll = () => {
      if (eofResult.value) return

      let element = scrollComponent.value

      if (!isLoading.value && element.getBoundingClientRect().bottom < window.innerHeight) {
        scroll()
      }
    }

    onMounted(() => {
      if (!checkPermission()) {
        return
      }

      window.addEventListener("scroll", handleScroll)
    })

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll)
    })

    function checkPermission() {
      if (!Permission.hasPermissions("admin_post_tags")) {
        setNoPermission()
        return false
      }

      return true
    }

    function setNoPermission() {
      noPermission.value = true
    }

    function isForbiddenPage() {
      return noPermission.value
    }

    function getParams() {
      return params
    }

    function getQuery() {
      return query.value
    }

    function getClearResult() {
      return clearResult.value
    }

    function onUpdate() {
      onFilter({})
    }

    function onCreate() {
      onFilter({})
    }

    function onDelete() {
      onFilter({})
    }

    return {
      getParams,
      getQuery,
      getClearResult,
      onRender,
      onFilter,
      scrollComponent,
      onUpdate,
      onCreate,
      onDelete,
      isForbiddenPage,
      editorRoleId,
    }
  }
})

</script>

<style scoped src="./css/style.css"></style>
